import { useFormContext as f, Controller as g } from "../../node_modules/react-hook-form/dist/index.esm.js";
import "../../UI/style.js";
import "../../node_modules/classnames/index.js";
import "../../UI/FormGrid/formGrid2.js";
import { jsx as r } from "../../_virtual/jsx-runtime.js";
import { UIInputContainer as B } from "../../UI/FormGrid/InputContainer.js";
import "../../UI/Input/UIInputText.js";
import "../../UI/Input/UIInputDate.js";
import "../../UI/Input/UIInputCheckbox.js";
import "../../UI/Input/UIInputFile.js";
import "../../UI/Input/UIInputTextArea.js";
import "../../UI/Blocks/Button/Button.js";
import "../../UI/Blocks/Emphasis/emphasis2.js";
import "../../UI/Blocks/Card/card2.js";
import "react";
import "../../UI/Blocks/Toaster/toast2.js";
import "../../UI/Blocks/Toaster/toaster2.js";
import { UIInputButtonGroup as C } from "../../UI/Input/UIInputButtonGroup.js";
function J({
  name: n,
  disabled: i,
  onChange: m,
  variant: e,
  options: u,
  label: a,
  size: p,
  className: s
}) {
  const {
    control: l
  } = f();
  return /* @__PURE__ */ r(g, {
    name: n,
    control: l,
    render: ({
      field: t,
      fieldState: {
        error: o,
        isTouched: I
      }
    }) => /* @__PURE__ */ r(B, {
      name: t.name,
      label: a,
      size: p,
      errorMessage: o == null ? void 0 : o.message,
      children: /* @__PURE__ */ r(C, {
        hasError: !!o,
        options: u,
        size: p,
        className: s,
        disabled: i,
        ref: t.ref,
        value: t.value,
        onBlur: t.onBlur,
        variant: e,
        onChange: m ? (c) => m(c.target.value, I) : t.onChange
      })
    })
  });
}
export {
  J as InputButtonGroup
};
//# sourceMappingURL=InputButtonGroup.js.map
